import { render, staticRenderFns } from "./AlertMiddleware.vue?vue&type=template&id=d66a730a"
import script from "./AlertMiddleware.vue?vue&type=script&lang=js"
export * from "./AlertMiddleware.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports